import React from "react";

import {
  CurrentUserWithAccountsDocument,
  CurrentUserWithAccountsQuery,
} from "@/apollo/types";
import { useApolloClient } from "@apollo/client";

import * as routeHelpers from "./routeHelpers";

export function useNavigateToWorkspace() {
  const client = useApolloClient();

  return React.useMemo(() => {
    const navigateBySlug = (slug: string, search?: Record<string, any>) => {
      window.location.href =
        routeHelpers.workspaceRoute(slug) +
        (search ? `?${new URLSearchParams(search)}` : "");
    };

    return {
      bySlug: navigateBySlug,
      byId: async (accountId: string, search?: Record<string, any>) => {
        try {
          // The account may have been joined just now (e.g. an accepted
          // invitation), so fetch a fresh accounts list to resolve its slug.
          const result = await client.query<CurrentUserWithAccountsQuery>({
            query: CurrentUserWithAccountsDocument,
            fetchPolicy: "network-only",
            context: {
              skipXAccountIdHeader: true,
            },
          });
          const slug = result.data?.current.accounts?.find(
            (x) => x.id === accountId,
          )?.slug;
          if (slug !== undefined) {
            navigateBySlug(slug, search);
          }
        } catch {
          //
        }
      },
    };
  }, [client]);
}
